module.exports = __webpack_public_path__ + "static/media/icon-feed.bcddcef0.svg";